 
namespace TabAurous.ECommerce {
    import fld = ShippingBOMRow.Fields;  
    @Serenity.Decorators.registerClass()
    export class ShippingBOMEditor extends _Ext.BOMGridEditor<ShippingBOMRow> { 
        protected getDialogType() { return ShippingBOMDialog; }
        protected getLocalTextPrefix() { return ShippingBOMRow.localTextPrefix; } 
        public ECommExchangeRate: number;

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as ECommerce.ShippingItemsDialog).CalculateTotals();
                }
            })

        } 

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        }

        

        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.RawMaterialMasterSelectGrid;

            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                onClick: () => {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var Purchasedetails = [];
                        var ratelistId = this.RateListId;
                        selectedItems2.forEach(function (value) {
                            var prdid = value.ProductId;

                            var PrdDetails = value;

                            var Pieces = 0;
                            var Weight = 0.01;
                            var Rate = 0;
                            var Amount = 0;

                            if (PrdDetails.ItemTypeId == 104) {
                                var MetalRate = GetItemRateHelper.GetGetMetalRate(PrdDetails.ProductTypeId);
                                Rate = MetalRate;
                                Amount = Rate * Weight * PrdDetails.Purity;

                            }
                            else {
                                var ItemRate = GetItemRateHelper.GetSalesRate(PrdDetails.AttributeId, ratelistId);
                                Rate = ItemRate;
                                Pieces = 1;
                                if (PrdDetails.CalcOnId == 3) {
                                    Amount = Rate * Pieces
                                }
                                else {
                                    Amount = Rate * Weight;
                                }
                            }


                            var PurchaseBom: ShippingBOMRow = {
                                BOMProductId: prdid,

                                ProductCode: value.ProductCode,
                                BOMAttributeId: value.AttributeId,
                                Attribute: PrdDetails.Attribute,
                                ItemType: PrdDetails.ItemType,
                                ItemTypeId: PrdDetails.ItemTypeId,

                                StoneColorId: PrdDetails.StoneColorId,
                                MetalColorId: PrdDetails.MetalColorId,
                                KaratId: PrdDetails.KaratId,

                                BomRate: Rate,
                                Pieces: Pieces,
                                Weight: Weight,
                                CalcOn: value.CalcOnId,
                                ShapeId: PrdDetails.ShapeId,
                                QualityId: PrdDetails.QualityId,

                                Purity: PrdDetails.Purity,
                                BomAmount: Amount
                            };
                            Purchasedetails.push(PurchaseBom);

                        });


                        for (let PurchaseDetail of Purchasedetails) {
                            PurchaseDetail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(PurchaseDetail);
                        }
                    }

                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
         
    }
}